import { route } from "preact-router";
import type { RoutableProps } from "preact-router";
import { confirmReview } from "../api";
import { ConfirmStatusView } from "../components/confirmStatusView";
import { useTokenConfirmation } from "../hooks/useTokenConfirmation";
import { toErrorPath, toThankYouPath } from "../routes";
import type { ConfirmReviewResponse, ErrorType } from "../types";

const DATE_FORMAT = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function ConfirmScreen(_props: RoutableProps) {
  const error = useTokenConfirmation(
    confirmReview,
    (res: ConfirmReviewResponse) => {
      if (res.status === "ok") {
        route(
          toThankYouPath({
            firstName: res.firstName,
            companyName: res.companyName,
            rating: res.rating,
          }),
          true
        );
        return;
      }
      if (res.status === "already") {
        const date = res.confirmedAt
          ? DATE_FORMAT.format(new Date(res.confirmedAt))
          : undefined;
        route(toErrorPath("already", { date }), true);
        return;
      }
      route(toErrorPath(res.status as ErrorType), true);
    }
  );

  return <ConfirmStatusView error={error} />;
}
